<template>
	<div class="home" style="text-align: center;">
		<!--基本信息-->
		<div class="basic-box f-cb">
			<div class="f-fl f-fl-box">
				<div class="f-cb visiting">
					<img :src="UserPortrait" class="f-fl viicon" />
					<div class="f-fr">
						<div class="context-box">
							<!--{{useState}}-->
							<p>您好
								<span class="striping" v-if="pastdue">|</span>
								<span class="warn">{{pastdue}}</span>
								<span class="striping" v-if="useState">|</span>
								<span @click="$router.push({ path: 'perfect' })" class="warn">{{useState}}</span>
								
							</p>
							<p>{{$store.state.commonalityData.name }}</p>
						</div>
					</div>

				</div>
				<el-button size="medium " style="margin-top: 22px; width: 70%;border-color: #1B59A8;" plain @click="shuttle"> <span class="adhere-color">{{$store.state.commonalityData.IdcodeUserId !=''? "我的资料":"完善资料" }}</span> </el-button>

			</div>
			<div class="function-box f-fl">
				<p class="hint">常用功能 </p>
				<div class="sign">
					<!-- <el-button type="primary" @click="$router.push({name:'productregister'})" style="padding: 16px 42px;  "> 注册码标</el-button> -->
					<el-button type="primary" @click="showUrl()" style="padding: 16px 42px;  "> 注册码标</el-button>
					<!-- <el-button type="primary" @click="$router.push({name:'genrelist'})" style="padding: 16px 42px;"> 码标解析 </el-button> -->
				</div>
			</div>

		</div>
		<!--基本信息-->
		<!--流程-->
		<!-- <div class="flow-box">
			<h2 class="tit">码标注册流程</h2>
			<div class="flow-img">
				<img src="../assets/imgs/LIUC.png" />
			</div>
		</div> -->
		<!--流程-->

	</div>
</template>

<script>
	export default {
		name: 'home',
		data() {
			return {
				activeName: 'first',
				UserPortraitURL: '',
				useState: '',
				pastdue: '',
			}
		},
		computed: {
			UserPortrait() {
				return this.UserPortraitURL != '' ? this.UserPortraitURL : require('@/assets/imgs/profile.png')
			}
		},
		created() {
			if(this.$store.state.commonalityData.IdcodeUserId){
				this.$http.get(this.$api + '/organUnit/getUnitLogoByID').then(resolve => {
					if(resolve.body.result === 1) {
						this.UserPortraitURL = resolve.body.entity.unitLogo;
						this.useState = resolve.body.entity.operationTip;
						this.pastdue = resolve.body.entity.expireTip;
					}
				})	
			}
		},
		methods: {
			shuttle() {
				this.$router.push({
					name: 'perfect',
				})
			},
			showUrl() {
				this.$http.post(this.$api + '/websiteManage/domanIntercept', {
					domain: window.location.protocol + "//" + window.location.host,
				}).then(res => {
					var newUrl = res.data.entity.domain
					window.location.href = newUrl
				})
			}
		}
	}
</script>
<style lang="scss">
	@import "@/assets/css/whole.scss";
	.adhere-color {
		color: $theme-color;
	}
	
	.home {
		/*padding: 0 54px;*/
		text-align: center;
		/*border: solid red 1px;*/
		text-align: left;
		.formbox {
			padding: 0 20px;
			/*width: 70%;*/
			/*margin: 0 auto;*/
		}
		.basic-box {
			/*display: inline-block;*/
			padding: 27px 0;
			/*border: solid red 1px;*/
			.f-fl-box {
				/*position: ;*/
				/*display: ;*/
				width: 320px;
				/*text-align:left ;*/
				padding: 57px 54px 57px 0px;
				/*border: solid red 1px;*/
				.visiting {
					/*width: 37px;*/
					/*padding: 0 54px;*/
					/*border: solid red 1px;*/
					.viicon {
						/*display: inline-block;*/
						width: 37px;
						height: 37px;
						padding: 0;
						/*display: inline-block;*/
						position: relative;
						margin-right: -37px;
					}
					.f-fr {
						width: 100%;
						text-align: left;
						/*border: solid red 1px;*/
					}
					.context-box {
						/*padding-left: 53px;*/
						width: 75%;
						margin-left: 48px;
						/*border: solid red 1px;*/
						p {
							text-align: left;
							font-size: 14px;
							color: #333333;
						}
					}
				}
			}
			.function-box {
				border-left: solid 1px #dddddd;
				display: inline-block;
				/*width: 100%;*/
				padding: 75px 54px 57px 84px;
				.hint {
					text-align: left;
					font-size: 15px;
					font-weight: 600;
					color: #2b80bc;
				}
				.sign {
					margin-top: 22px;
				}
			}
		}
		.flow-box {
			margin-top: 23px;
			/*border: solid red 1px;*/
			text-align: left;
			.tit {
				text-align: center;
				/*width: 1000px;*/
				width: 70%;
				padding: 0 116px;
				/*min-width: 1000px;*/
				font-size: 18px;
				font-weight: 500;
				color: #2b80bc;
			}
			.flow-img {
				margin-top: 24px;
				width: 70%;
				min-width: 800px;
				padding: 79px 116px;
				border: solid #e8e8e8 1px;
				text-align: center;
				/*text-align: center;*/
			}
		}
	}
	
	.warn {
		cursor: pointer;
		color: #F56C6C;
	}
	
	.striping {
		padding: 0 3px;
		vertical-align: top;
		color: #666666;
	}
</style>